/**
 * Design version list — front/back history with select + Edit plan (Phase 11.3).
 */

/**
 * @param {HTMLElement} container
 * @param {Array<Record<string, unknown>>} designs
 * @param {'front'|'back'} activeSide
 * @param {(designId: number, side: 'front'|'back') => void} onSelect
 * @param {{
 *   briefEnabled?: boolean,
 *   onEditPlan?: (design: Record<string, unknown>) => void,
 * }=} [options]
 */
export function renderDesignHistory(container, designs, activeSide, onSelect, options) {
    container.innerHTML = '';

    const briefEnabled = Boolean(options && options.briefEnabled);
    const onEditPlan = options && typeof options.onEditPlan === 'function'
        ? options.onEditPlan
        : null;

    const filtered = (designs || []).filter((d) => d.side === activeSide);
    if (filtered.length === 0) {
        container.innerHTML = '<p class="small text-muted mb-0">No designs yet for this side.</p>';

        return;
    }

    const list = document.createElement('div');
    list.className = 'tc-design-history';

    filtered.forEach((design) => {
        const row = document.createElement('div');
        row.className = 'tc-design-history__row';
        if (design.is_selected) {
            row.classList.add('is-selected');
        }

        const status = String(design.generation_status || '');
        const source = String(design.source || 'ai');
        let sourceLabel = status;
        if (source === 'upload') {
            sourceLabel = 'as-is';
        } else if (source === 'copy') {
            sourceLabel = 'copy';
        } else if (source === 'text') {
            sourceLabel = 'text';
        } else if (source === 'scale') {
            sourceLabel = 'size';
        }
        const label = 'v' + design.version + ' · ' + sourceLabel;

        const selectBtn = document.createElement('button');
        selectBtn.type = 'button';
        selectBtn.className = 'tc-design-history__item';
        selectBtn.textContent = label;
        selectBtn.disabled = status === 'pending' || status === 'failed';
        selectBtn.addEventListener('click', () => {
            onSelect(Number(design.id), activeSide);
        });
        row.appendChild(selectBtn);

        const canEditPlan = briefEnabled
            && onEditPlan
            && source === 'ai'
            && status === 'ok';
        if (canEditPlan) {
            const editBtn = document.createElement('button');
            editBtn.type = 'button';
            editBtn.className = 'tc-design-history__edit';
            editBtn.textContent = 'Edit plan';
            editBtn.title = 'Load this design plan into AI Generate';
            editBtn.addEventListener('click', (ev) => {
                ev.preventDefault();
                ev.stopPropagation();
                onEditPlan(design);
            });
            row.appendChild(editBtn);
        }

        list.appendChild(row);
    });

    container.appendChild(list);
}
